import React, { useState } from "react";
import { useDashboardVM } from "./hooks/useDashboardVM";
import useDashboard from "../../hooks/useDashboard";
import DashboardHeader from "./DashboardHeader";
import KpiCard from "./KpiCard";
import MainChart from "./MainChart";
import TopListCard from "./TopListCard";
import HighlightCard from "./HighlightCard";
import TopProductsCard from "./TopProductsCard";
import StockSummaryCard from "./StockSummaryCard";
import LoadingScreen from "src/shared/components/LoadingScreen";



function Dashboard() {
  const today = new Date().toISOString().split("T")[0];

  const [date, setDate] = useState({
    from: today,
    to: today,
  });

  const { data, loading } = useDashboard(date.from, date.to);
  const vm = useDashboardVM(data);

  if (loading || !vm) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6 bg-gray-50 min-h-screen flex flex-col gap-6">

      {/* Header */}
      <DashboardHeader date={date} setDate={setDate} />

      {/* KPI */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {vm.kpis.map((kpi, i) => (
          <KpiCard key={i} {...kpi} />
        ))}
      </div>

      {/* 🔥 OSB Highlight */}
      <HighlightCard title="Outstanding Balance" value={vm.osb} />

      {/* Chart */}
      <MainChart data={vm.chart} />

      {/* Stock Summary */}
      <StockSummaryCard stock={vm.stock} />

      {/* Bottom Grid */}
      <div className="grid md:grid-cols-3 gap-4">

        <TopListCard
          title="Top Customers"
          data={vm.customers}
          nameKey="customerName"
          valueKey="totalSpent"
        />

        <TopListCard
          title="Top Orders"
          data={vm.orders}
          nameKey="order_id"
          valueKey="total_amount"
        />

        <TopProductsCard data={vm.products} />
      </div>



      <div>
        {(loading || !vm) && (
          <LoadingScreen />
        )}
      </div>

    </div>
  );
}

export default Dashboard;